import { atom, getDefaultStore } from 'jotai';
import type { User, UserManager } from 'oidc-client-ts';

export const oidcUserAtom = atom<User | null>(null);
export const isLoadingOidcUserAtom = atom<boolean>(true);

// Seeds the atoms from storage, then keeps them in sync with UserManager
// events. Writes go through the default Jotai store because events fire
// outside React.
export const initOidcState = (userManager: UserManager): void => {
  const store = getDefaultStore();

  const setUser = (user: User | null): void => {
    store.set(oidcUserAtom, user && !user.expired ? user : null);
  };

  userManager.events.addUserLoaded((user) => setUser(user));
  userManager.events.addUserUnloaded(() => setUser(null));
  userManager.events.addUserSignedOut(() => setUser(null));
  userManager.events.addAccessTokenExpired(() => setUser(null));
  userManager.events.addSilentRenewError(() => setUser(null));

  userManager
    .getUser()
    .then((user) => setUser(user))
    .catch(() => setUser(null))
    .finally(() => {
      store.set(isLoadingOidcUserAtom, false);
    });
};
